import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CART_LOC } from "@iscr/views/prods/ShopUtil";
import { useWatchRecord } from "@iscr/xAppLib/Hooks";
export const CartCount = () => {
    var _a, _b, _c;
    const cart = (_a = useWatchRecord(`${CART_LOC()}`)) !== null && _a !== void 0 ? _a : {};
    const { qty = {}, promotions = [] } = cart;
    const count = (_c = (_b = Object.values(qty)) === null || _b === void 0 ? void 0 : _b.filter(Boolean)) === null || _c === void 0 ? void 0 : _c.length;
    const promotionCount = promotions === null || promotions === void 0 ? void 0 : promotions.reduce((acc, val) => acc + ((val === null || val === void 0 ? void 0 : val.quantity) || 1), 0);
    const totalCount = count + promotionCount;
    return (_jsxs("div", { className: "flex items-center", children: ["Cart", totalCount > 0 && (_jsx("span", { className: 'bg-icosm-tertiary ml-1 rounded-full flex items-center justify-center text-icosm-secondary text-[12px] w-[1.5rem] h-[1.5rem] tracking-normal', children: totalCount }))] }));
};
